// extracted by mini-css-extract-plugin
module.exports = {"container":"Keyword_container__1I11N","center":"Keyword_center__2gH-U","body":"Keyword_body__1VvZ2"};